import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { i18n } from './lang/index'

// 定义全局方法
Vue.prototype.$aliTranslatezHtoen = function(text) {
    // TODO: 实现翻译功能
    return text;
};

Vue.use(ElementUI);

Vue.config.productionTip = false

// 全局错误处理
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue全局错误:', err, info);
  // 阻止错误传播到 webpack-dev-server 的错误覆盖层
  return false;
}

// 全局未捕获错误处理
window.addEventListener('error', function(event) {
  console.error('全局未捕获错误:', event.error);
  // 阻止默认错误处理
  event.preventDefault();
})

// 全局未捕获 Promise 错误处理
window.addEventListener('unhandledrejection', function(event) {
  console.error('未处理的Promise拒绝:', event.reason);
  // 阻止默认错误处理
  event.preventDefault();
})

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
